import { render, staticRenderFns } from "./DialogLoading.vue?vue&type=template&id=2e18b194&scoped=true&"
import script from "./DialogLoading.vue?vue&type=script&lang=js&"
export * from "./DialogLoading.vue?vue&type=script&lang=js&"
import style0 from "./DialogLoading.vue?vue&type=style&index=0&id=2e18b194&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e18b194",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDialog,VRow})
